/**
 * 「token 即授权」的公开端点判定 —— axios 拦截器的两处特殊处理共用这一个入口：
 *   1. 请求拦截器：命中即**不贴任何登录态头**（匿名访客没有登录态；且必须在 Clerk
 *      分支之前短路，否则 getToken() 可能永久挂起，见 uploadSession404Rule.ts）。
 *   2. 响应拦截器：命中时 404 不弹全局 toast（token 失效是公开页的正常业务态，
 *      页面自己渲染失效卡片）。
 *
 * 目前两类公开页：
 *   - MCP 上传落地页 `/upload/:token` → `isUploadSessionRequestUrl`（三个形状）；
 *   - 外部承包商工单页 `/job/:token` → `isContractorLinkPublicRequestUrl`。
 *
 * 与 uploadSession404Rule 同一个「fails closed」口径：只认**具体形状**，宁可少匹配
 * （新端点退化成默认行为，仍然安全）也不多匹配（误伤需要登录的 `/pms/*` 路径，
 * 等于把真实请求的认证头静默拿掉）。员工侧 `/pms/tasks/{id}/contractor-links*`
 * 是登录态接口，**不在**这里。
 */
import { isUploadSessionRequestUrl } from './uploadSession404Rule'

/** 公开承包商端点的前缀（main-api `/api/v1/external/contractor-links/{token}`）。 */
export const CONTRACTOR_LINK_PUBLIC_BASE = '/external/contractor-links'

/**
 * 外部承包商工单页的公开端点：
 *   GET  /external/contractor-links/{token}
 *   GET  /external/contractor-links/{token}/door-code
 *   POST /external/contractor-links/{token}/uploads/presign
 *   POST /external/contractor-links/{token}/uploads/commit
 *   POST /external/contractor-links/{token}/notes
 *   POST /external/contractor-links/{token}/submit
 *
 * 允许绝对 URL（axios 的 baseURL 已含 `/api/v1`，调用方传相对路径；这里只看路径尾部），
 * 但 token 段之后只认上面这几个后缀，其它一律不算。
 */
export function isContractorLinkPublicRequestUrl(url: string | undefined): boolean {
  return /\/external\/contractor-links\/[^/?#]+(?:\/(?:door-code|notes|submit|uploads\/(?:presign|commit)))?(?:[?#].*)?$/.test(
    url ?? '',
  )
}

/** 任一公开 token 端点。axios-config 只调这一个。 */
export function isPublicTokenRequestUrl(url: string | undefined): boolean {
  return isUploadSessionRequestUrl(url) || isContractorLinkPublicRequestUrl(url)
}
